import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../Context/api";

function VerifyChangeEmail() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await API.get(`/users/verify-email/${token}`);
        setMessage(
          response.data.message ||
            "Email verified successfully! Redirecting to login..."
        );
        setMessageType("success");
        // Redirect after 5 seconds
        setTimeout(() => {
          navigate("/login");
        }, 5000);
      } catch (error) {
        setMessage(
          error.response?.data?.message ||
            "Network error or server not responding. Please try again."
        );
        setMessageType("error");
      }
    };
    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-6 bg-white p-8 rounded-xl shadow-lg">
        {/* Message Display */}
        {message && (
          <div
            className={`text-center text-sm p-3 rounded-md ${
              messageType === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message}
          </div>
        )}

        {/* Heading */}
        <h2 className="text-center text-3xl font-bold text-gray-900">
          Email Verification
        </h2>

        {/* Loading State */}
        {!message && (
          <p className="text-center text-gray-600 text-base">
            Verifying your email address. Please wait...
          </p>
        )}
      </div>
    </div>
  );
}

export default VerifyChangeEmail;
